import {Component, OnInit, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';

import {AlertaEnum, DialogoEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';

import {AlumnoModalComponent} from '@contenido/AppContent/global/alumno/alumno.component';
import {Colaborador} from '@modelo/catalogo/Colaborador.model';
import {Alumno} from '@modelo/global/Alumno.model';

@Component(
    {
        selector: 'colaborador_general',
        templateUrl: './colaborador_general.template.html',
        styleUrls: ['../colaborador.component.scss']
    })

export class ColaboradorGeneralComponent implements OnInit {
    @Input() id!: number;
    @Input() disabled!: boolean;
    @Output() salir = new EventEmitter();

    public entidadOLD: Colaborador;
    public entidad: Colaborador;

    SelGenero: any[];
    SelSituacionConyugal: any[];
    SelNacionalidad: any[];
    SelTipoSanguineo: any[];

    SelEstado: any[];
    SelMunicipio: any[];
    SelColonia: any[];
    SelParentesco: any[];

    SelTipoColaborador: any[];
    SelEstatusColaborador: any[];

    public errorActivo!: boolean;

    verotracolonia: boolean = false;

    dataTable: Array<Alumno>;
    @ViewChild('alumno') private alumno!: AlumnoModalComponent;

    formato: number = 0;

    loaded: boolean = false;
    configuracionDatePicker: any;

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService) {
        this.entidad = new Colaborador();
        this.entidadOLD = new Colaborador();

        this.SelGenero = [{nombre: "Maculino", valor: 'MASCULINO'}, {nombre: "Femenino", valor: 'FEMENINO'}]
        this.SelSituacionConyugal = [];
        this.SelNacionalidad = [];
        this.SelTipoSanguineo = [];
        this.SelEstado = [];
        this.SelMunicipio = [];
        this.SelColonia = [];
        this.SelParentesco = [];
        this.SelTipoColaborador = [];
        this.SelEstatusColaborador = [];

        this.dataTable = [];

        //Formato de nombres propios
        let formato = this.sistemaService.parametros.find(x => x.nombre == "FormatoNombre");
        if (formato) {
            this.formato = formato.valor
        }
    }

    ngOnInit() {
        this.setHoy();
        this.setSituacionConyugal();
        this.setNacionalidad();
        this.setTipoSanguineo();
        this.setEstado();
        this.setParentesco();
        this.setTipoColaborador();
        this.setEstatusColaborador();

        if (this.id) {
            this.setEntidad();
            this.BuscarHijo();
        }
    }

    setEntidad() {
        this.appService.Get("configuracionrh/colaborador/" + this.id).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.entidad = new Colaborador(res.data);
                this.setMunicipio(this.entidad.estadoid);
                this.setColonia(this.entidad.municipioid);
                this.loaded = true;
                this.entidadOLD = new Colaborador(this.entidad);
            } else {
                this.salir.next();
            }
        })
    }


    setHoy() {
        this.appService.Get("catalogo/hoy").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.configuracionDatePicker = {disableSince: {year: res.data.year, month: res.data.month, day: res.data.day}, openSelectorOnInputClick: false};
            }
        });
    }
    setSituacionConyugal() {
        this.appService.Get("catalogo/situacionconyugal").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelSituacionConyugal = res.data
            }
        });
    }
    setNacionalidad() {
        this.appService.Get("catalogo/nacionalidad").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelNacionalidad = res.data
            }
        });
    }
    setTipoSanguineo() {
        this.appService.Get("catalogo/tiposanguineo").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelTipoSanguineo = res.data
            }
        });
    }

    setEstado() {
        this.appService.Get("catalogo/estado/").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelEstado = res.data

            }
        });
    }
    setMunicipio(estadoid: number) {
        if (!estadoid) {
            this.SelMunicipio = [];
            this.entidad.municipioid = 0;
            this.setColonia(0);
            return;
        }
        this.appService.Get("catalogo/municipio/" + estadoid).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelMunicipio = res.data;
            }
        });
    }
    setColonia(municipioid: number) {
        if (!municipioid) {
            this.SelColonia = [];
            this.entidad.coloniaid = 0;
            return;
        }
        this.appService.Get("catalogo/colonia/" + municipioid + "/" + this.entidad.cp).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelColonia = res.data
                let otros = {"coloniaid": 0, "nombre": "Otros"}
                this.SelColonia.unshift(otros)
                if(this.entidad.coloniaid == 0){
                    this.verotracolonia = true;
                }
            }
        });
    }
    setOtraColonia(coloniaid:any){
        if(coloniaid !== ""){
            if(coloniaid == 0){
                this.verotracolonia = true;
            }else{
                this.verotracolonia = false;
                this.entidad.otracolonia = "";
            }
        }else{
            this.verotracolonia = false;
            this.entidad.otracolonia = "";
        }
    }

    setParentesco() {
        this.appService.Get("catalogo/parentesco").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelParentesco = res.data
            }
        });
    }

    setTipoColaborador() {
        this.appService.Get("catalogo/tipocolaborador").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelTipoColaborador = res.data
            }
        });
    }
    setEstatusColaborador() {
        this.appService.Get("catalogo/estatuscolaborador").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelEstatusColaborador = res.data
            }
        });
    }

    setDireccion(cp: string) {
        if (this.entidad.estadoid && this.entidad.municipioid && this.entidad.coloniaid) {
            //return;
        }
        if (cp.length == 0) {
            this.entidad.estadoid = 0;
            this.setMunicipio(this.entidad.estadoid);
            this.entidad.municipioid = 0;
            this.setColonia(this.entidad.municipioid);
            this.entidad.coloniaid = 0;
            return;
        }

        if (cp.length != 5) {
            return;
        }

        this.appService.Get("catalogo/direccion/" + cp).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.entidad.estadoid = res.data.estadoid;
                this.SelMunicipio = res.data.selmunicipio
                this.entidad.municipioid = res.data.municipioid;
                this.SelColonia = res.data.selcolonia;
                if(this.SelColonia.length > 0){
                    let otros = {"coloniaid": 0, "nombre": "Otros"}
                    this.SelColonia.unshift(otros)
                }
                this.entidad.coloniaid = res.data.coloniaid;
                if(this.entidad.coloniaid != 0){
                    this.verotracolonia = false;
                    this.entidad.otracolonia = "";
                }
            }
        });
    }

    setDatosAcademicos(tipocolaboradorid: number) {
        if (tipocolaboradorid != 2 && tipocolaboradorid != 0) {
            this.entidad.experienciainstituto = 0;
            this.entidad.experienciasep = "";
            this.entidad.autorizaciondgb = "";
            this.entidad.autorizacionsep = "";
        }
    }


    Guardar(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.disabled && this.entidad.colaboradorid) {
                resolve({id: this.entidad.colaboradorid});
                return;
            }

            let respuesta = this.Validar();
            if (respuesta != true) {
                return this.mensajeService.Alerta(AlertaEnum.Warning, respuesta);
            }

            if (this.Cambios() && this.entidad.colaboradorid) {
                resolve({id: this.entidad.colaboradorid});
                return;
            }

            let data = new Colaborador(this.entidad);
            this.appService.Post("configuracionrh/colaborador", data).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                    this.entidad.colaboradorid = res.data.id;
                    this.id = this.entidad.colaboradorid;
                    this.entidad.urlfotografia = res.data.urlfotografia;

                    this.entidadOLD = new Colaborador(this.entidad);
                    resolve({id: this.entidad.colaboradorid, cambio: true});
                }
            })
        })
    }

    Cambios() {
        if (JSON.stringify(this.entidadOLD) === JSON.stringify(this.entidad)) {
            return true;
        } else {
            return false;
        }
    }

    Validar(): any {
        this.errorActivo = true;
        if (!this.entidad.nombre || !this.entidad.nombre.trim()) {
            return "Ingrese un nombre";
        }

        if (!this.entidad.apellidopaterno || !this.entidad.apellidopaterno.trim()) {
            return "Ingrese un apellido paterno";
        }
        if (!this.entidad.apellidomaterno || !this.entidad.apellidomaterno.trim()) {
            return "Ingrese un apellido materno";
        }
        if (this.entidad.fechanacimiento == "" || this.entidad.fechanacimiento?.trim()) {
            if (!this.entidad.fechanacimiento.match(/^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/)) {
                return "El valor y/o formato de la fecha es incorrecto, debe ser dd/mm/yyyy";
            }
        }

        if (!this.entidad.rfc.match(this.sistemaService.RFCFisicaER)) {
            return "Ingrese un RFC válido";
        }
        //if (this.entidad.curp.trim()) {
        if (!this.entidad.curp.match(this.sistemaService.CURPER)) {
            return "Ingrese un CURP válido";
        }
        //}
        if (!this.entidad.nomina || !this.entidad.nomina.trim()) {
            return "Ingrese una nómina";
        }
        if (!this.entidad.telefonocelular.match(this.sistemaService.TelefonoER)) {
            return "Ingrese un teléfono celular válido";
        }
        if (!this.entidad.emailpersonal.match(this.sistemaService.CorreoER)) {
            return "Ingrese un correo personal válido";
        }
        if (!this.entidad.emailinstitucional.match(this.sistemaService.CorreoER)) {
            return "Ingrese un correo institucional válido";
        }
        if (this.entidad.tipocolaboradorid == null) {
            return "Ingrese un tipo de colaborador";
        }
        if (!this.entidad.estatuscolaboradorid) {
            return "Ingrese un estatus de colaborador";
        }
        if (!this.entidad.usuario) {
            return "Ingrese un usuario";
        }
        return true;
    }

    AgregarHijo() {
        if (this.id) {
            this.alumno.Modal()
        } else {
            if (this.Validar() === true) {
                this.Guardar().then(res => this.alumno.Modal());
            } else {
                return this.mensajeService.Alerta(AlertaEnum.Warning, "Primero debes completar los datos requeridos");
            }
        }
    }

    GuardarHijo(alumnos: Array<Alumno>) {
        let result = this.dataTable.find(o1 => alumnos.some(o2 => o1.alumnoid === o2.alumnoid));
        if (result) {
            return this.mensajeService.Alerta(AlertaEnum.Warning, "El alumno " + result.matricula + " ya se encuentra registrado");
        }

        this.appService.Post("configuracionrh/colaborador/hijo/" + this.id, alumnos).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                this.BuscarHijo();
                this.alumno.CerrarModal();
            }
        })
    }

    BuscarHijo() {
        this.appService.Get("configuracionrh/colaborador/hijo/" + this.id).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.dataTable = res.data;
            }
        })
    }

    EliminarAlumno(e: Alumno) {
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                this.appService.Delete("configuracionrh/colaborador/hijo/" + e.alumnoid + "/" + this.id).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        this.BuscarHijo();
                    }
                })
            }
        })
    }

}
